/** @format */

import { AxiosInstance } from "../../../utils/AxiosInstance";
import { environment } from "../../../env";

const axiosInstance = new AxiosInstance(`${environment.API}/marketReport/`, "syndicationReport").getAxiosInstance();
// const __axiosInstance = {
//   get: axiosInstance.get,
//   post: (section, data) => new Promise((res, rej) => {
//     setTimeout(() => res(data), 1500);
//     console.log('data', data)
//   })
// }
const SERVICE = {
  getSyndicationRegions: () => axiosInstance.get("regions"),
  getSyndication: (date, regionId, channelId) =>
    axiosInstance.get("getAdminMarketReport", { params: { regionId, reportDate: date, channelId } }),
  getAdvertisements: () => axiosInstance.get("advertisementBanners"),
  saveEarlyMarkets: (earlyMarketsData) => axiosInstance.post("earlyMarket", earlyMarketsData),
  savePreviousSession: (previousSessionData) => axiosInstance.post("previous", previousSessionData),
  saveMarketOverview: (marketOverviewData) => axiosInstance.post("marketOverview", marketOverviewData),
  saveAdLinks: (adLinksData) => axiosInstance.post("advertisementBanner", adLinksData),
  saveOutsideMarket: (outsideMarketData) => axiosInstance.post("outsideMarket", outsideMarketData),
  saveWeather: (weatherData) => axiosInstance.post("weather", weatherData),
  saveSAWeather: (weatherData) => axiosInstance.post("SAWeather", weatherData),
  saveEconomicIndicator: (saveEconomicIndictor) => axiosInstance.post("economicIndicator", saveEconomicIndictor),
};

export default SERVICE;
